import React from 'react';
import './Loader.css'; // Archivo de estilos para el loader

const Loader = () => {
    return (
        <div className="loader-overlay">
            <div className="loader"></div>
        </div>
    );
};

export default Loader;
